import {
    Accordion, AccordionItem, AccordionTrigger, AccordionContent,
} from "@/components/ui/accordion";

const faqs = [
    {
        q: "Cât costă serviciile de brokeraj?",
        a: "Consultanța este 100% gratuită pentru tine. Brokerul este remunerat de compania de asigurări sau financiară cu care încheie contractul, fără a crește prețul tău. Practic, plătești exact cât ai plăti direct la asigurător — dar primești și consultanță obiectivă, cu acces la toată piața.",
    },
    {
        q: "Pot compara mai multe oferte fără să mă oblig la ceva?",
        a: "Da. Îți pregătim 2–3 variante comparate (preț, acoperiri, excluderi) și tu decizi în liniște. Nu există obligație de a semna. Cererea de ofertă este gratuită și fără angajament.",
    },
    {
        q: "Ce documente îmi trebuie pentru o ofertă RCA / CASCO?",
        a: "Pentru RCA: cartea de identitate, talonul auto (sau seria șasiu) și certificatul de înmatriculare. Pentru CASCO mai e nevoie de istoricul de daune. Ne ocupăm noi să cerem ofertele de la mai mulți asigurători simultan.",
    },
    {
        q: "Asigurarea de locuință PAD e suficientă?",
        a: "PAD-ul acoperă doar cutremur, inundații și alunecări de teren, cu o sumă fixă (10.000–20.000 €). Pentru protecție reală îți recomandăm și o poliță facultativă care acoperă incendiu, furt, vandalism, avarii instalații și bunurile din locuință.",
    },
    {
        q: "Pot beneficia de deducere fiscală la pensia privată?",
        a: "Da. La Pilonul III (pensia facultativă) contribuțiile voluntare beneficiază de deducere fiscală în limitele prevăzute de legislația în vigoare. La Pilonul II contribuția este reținută automat din salariu, conform legii. Îți putem prezenta toate fondurile disponibile pe piață și performanța lor istorică.",
    },
    {
        q: "Cât durează aprobarea unui credit ipotecar / Noua Casă?",
        a: "Pre-aprobarea durează 3–5 zile lucrătoare. Aprobarea finală, după evaluarea imobilului și a dosarului complet, durează în medie 3–6 săptămâni. Te ajutăm să pregătești dosarul corect din prima, ca să eviți întârzieri.",
    },
    {
        q: "Sunteți autorizați ASF? Cum vă pot verifica?",
        a: "Activăm ca asistenți în brokeraj pentru Safety Broker de Asigurare S.A. — broker autorizat ASF (Autoritatea de Supraveghere Financiară), parte a grupului global Acrisure. Putem pune la dispoziție numărul de înregistrare RAJ (Registrul Asistenților în Brokeraj) la cerere și poți verifica oricând statutul Safety Broker pe site-ul ASF (asfromania.ro).",
    },
];

export default function FAQ() {
    return (
        <section id="faq" data-testid="faq-section" className="bg-[#f5f3ec] py-24 lg:py-32">
            <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-4">
                    <div className="text-xs uppercase tracking-[0.2em] text-[#0d3d2e]/60 mb-4">
                        04 — Întrebări
                    </div>
                    <h2 className="font-display text-4xl sm:text-5xl text-[#0d3d2e] leading-[1.05] mb-6">
                        Răspunsuri<br />la întrebările frecvente.
                    </h2>
                    <p className="text-base text-[#1a1a1a]/65">
                        Nu găsești răspunsul aici? Scrie-ne sau sună-ne — îți răspundem în maxim 24h.
                    </p>
                </div>
                <div className="lg:col-span-8">
                    <Accordion type="single" collapsible className="space-y-3">
                        {faqs.map((f, i) => (
                            <AccordionItem
                                key={i}
                                value={`item-${i}`}
                                data-testid={`faq-item-${i}`}
                                className="border border-[#0d3d2e]/15 rounded-xl px-6 bg-[#fcfbf8]"
                            >
                                <AccordionTrigger className="text-left font-display text-xl text-[#0d3d2e] hover:no-underline py-5">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="text-[#1a1a1a]/75 text-base leading-relaxed pb-5">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </div>
        </section>
    );
}
